var iStockUrl = 'https://';
iStockUrl += 'istock.myshopapps.com/ajax/';
if (typeof iStockSelectClass === 'undefined') {
    var iStockSelectClass = ".swatch-element>label, #product-select, .selector-wrapper > select,  .single-option-selector, .single-option-selector__radio"
}
if (typeof iStockWraperClass === 'undefined') {
    var iStockWraperClass = 'form'
}
if (typeof iStockVarSelector === 'undefined') {
    var iStockVarSelector = '[name=id]'
}
var iStockShopId = 0;
var iStockavlDtFormat = '';
var istExcludeProd = '';
var istExcludeVar = '';
var availDates = [];
var iStockProduct = {};
var iStockpHandle = '';
var iStockVariant = {};
var iStockVarIdOld = 0;
if (typeof(Storage) !== "undefined" && sessionStorage.iStockShop) {
    if (sessionStorage.iStockShopId) {
        iStockShopId = sessionStorage.iStockShopId;
    }
    if (sessionStorage.iStockavlDtFormat) {
        iStockavlDtFormat = sessionStorage.iStockavlDtFormat;
    }
    if (sessionStorage.istExcludeProd) {
        istExcludeProd = sessionStorage.istExcludeProd;
    }
    if (sessionStorage.istExcludeVar) {
        istExcludeVar = sessionStorage.istExcludeVar;
    }
}
function iStockValidateEmail(emailId) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(emailId);
}
function istockGetVariant(iStockVarId, iStockVariants) {
    for (i = 0; i < iStockVariants.length; i++) {
        if (iStockVariants[i].id == iStockVarId) {
            return iStockVariants[i];
        }
    }
}
function istockNotifyClick(istockBtnObj) {
    istockBtnObj.attr("disabled", !0);
    istockBtnObj.css('background-color','#bbb');

    var istockFormWrap = istockBtnObj.parents(iStockWraperClass);
    istockFormWrap.find('.iStock-msg').removeClass('iStock-error').hide();
    var emailId = istockFormWrap.find('.iStock-email-id').val();
    console.log('Adding :: ' + iStockProduct.title + ' : ' + iStockVariant.title + ' : ' + emailId + ' : ' + iStockProduct.id + ' : ' + iStockVariant.id);
    if (!iStockValidateEmail(emailId)) {
        istockFormWrap.find('.iStock-msg').html(iStockErrorMsg).addClass('iStock-error').show();
        istockBtnObj.attr("disabled", !1);
        istockBtnObj.css('background-color','#d0121b');
    } else {
        jQuery.ajax({
            url: iStockUrl + 'add_notify.php',
            data: {
                shopId: iStockShopId,
                cust: emailId,
                vid: iStockVariant.id,
                pid: iStockProduct.id,
                vTitle: iStockVariant.title,
                pTitle: iStockProduct.title
            },
            dataType: 'jsonp',
            jsonpCallback: 'iStockAddNotifyCallback',
            success: function(json) {
                istockBtnObj.css('background-color','#d0121b');
                if (json.insertId != 0) {
                    istockFormWrap.find('.iStock-msg').html(iStockSuccessMsg).show();
                    istockFormWrap.find('input.iStock-email-id').val('');
                } else {
                    var emreg=/^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
                    if (emreg.test(emailId) == true) {
						iStockErrorMsg = 'Please try another email, such as ***@gmail.com，@yahoo.com...';
                    }
                    istockFormWrap.find('.iStock-msg').html(iStockErrorMsg).addClass('iStock-error').show();
                }
                if (typeof iStockAddFn !== 'undefined' && typeof iStockAddFn === 'function') {
                    iStockAddFn();
                }
            },
            error: function(err) {}
        }).done(function() {
            istockBtnObj.attr("disabled", !1);
            istockBtnObj.css('background-color','#d0121b');
        });
    }
}
function istockNotifyShow(product, istockFormWrap) {
    var iStockVarId = parseInt(istockFormWrap.find(iStockVarSelector).val());
    //console.log('istockNotifyShow called : ' + iStockVarId + ' :: iStockVarIdOld :' + iStockVarIdOld);
    //if (iStockVarId != null && iStockVarId != iStockVarIdOld) {
    if (iStockVarId != null) {
        var iStockProductId = product.id;
        if (istExcludeProd.indexOf(iStockProductId) >= 0) {
            console.log('product excluded ::' + iStockProductId);
            return ! 1;
        } else if (istExcludeVar.indexOf(iStockVarId) >= 0) {
            console.log('variant excluded ::' + iStockVarId);
            return ! 1;
        }
        iStockVariant = istockGetVariant(iStockVarId, product.variants);
        var istockShowNotify = !1;
        if (iStockVariant) {
            var preordertag = product.tags;
            if (iStockAllowPreorder && preordertag.indexOf("istock-preorder") != -1) {
                istockShowNotify = !0;
            } else if (iStockVariant.available == !1) {
                istockShowNotify = !0;
            }
        }
        if (istockShowNotify) {
            iStockVarIdOld = iStockVarId;
            if (typeof availDates[iStockVarId] !== 'undefined') {
                if (availDates[iStockVarId].type == '0') {
                    istockFormWrap.find(".iStock-availability").show().find("label").show();
                } else {
                    istockFormWrap.find(".iStock-availability").show().find("label").hide();
                }
                istockFormWrap.find(".iStock-availability").find("span").html(availDates[iStockVarId].val);
            } else {
                istockFormWrap.find(".iStock-availability").hide();
            }

            istockFormWrap.find(".iStock-wrapper").show();
            jQuery("#popLayer").show();
            if (typeof istockNotifyShowFn !== "undefined" && typeof istockNotifyShowFn === 'function') {
                istockNotifyShowFn();
            }
        } else {
            iStockVarIdOld = 0;
            istockFormWrap.find(".iStock-wrapper").hide();
            jQuery("#popLayer").hide();
        }
    }/*else{iStockVarIdOld=0;istockFormWrap.find(".iStock-wrapper").hide()}*/
}
function istockgetProduct(handle, istockFormWrap) {
    if (jQuery.isEmptyObject(iStockProduct) || iStockProduct.handle != handle) {
        jQuery.getJSON('/products/' + handle + '.js',
        function(product) {
            iStockProduct = product;
            var currentiStockWrap = istockFormWrap.find('.iStock-wrapper');
            if (currentiStockWrap.attr('handle') == '' || currentiStockWrap.attr('handle') != handle) {
                currentiStockWrap.attr('handle', iStockProduct.handle);
            }
            iStockProductId = iStockProduct.id;
            jQuery.ajax({
                url: iStockUrl + 'check-availability.php',
                data: {
                    shopId: iStockShopId,
                    pid: iStockProductId
                },
                dataType: 'jsonp',
                jsonpCallback: 'iStockGetAvaildtCallback',
                success: function(jsonDt) {
                    availDates = jsonDt;
                }
            }).done(function() {
                istockNotifyShow(iStockProduct, istockFormWrap);
            });
        });
    } else {
        istockNotifyShow(iStockProduct, istockFormWrap);
    }
}
function istockInitQv(qvObj, handle) {
    iStockVarIdOld = 0;
    setTimeout(function() {
        jQuery("body").addClass('iStock-qvopen');
        var iStockQvWrap = jQuery(iStockQvWrapper + ':visible');
        if (iStockQvWrap.find(iStockVarSelector).length > 0) {
            jQuery(".iStock-wrapper").hide().find('.iStock-msg').hide();
            istockgetProduct(handle, iStockQvWrap);
            if (typeof istockInitQvFn !== "undefined" && typeof istockInitQvFn === 'function') {
                istockInitQvFn();
            }
        } else {
            istockInitQv(qvObj, handle);
        }
    },
    300);
}
function istockCloseQv() {
    jQuery("body").removeClass('iStock-qvopen');
    setTimeout(function() {
        var istockFormWrap = jQuery('.iStock-wrapper').parents(iStockWraperClass + ':visible');
        iStockpHandle = istockFormWrap.find('.iStock-wrapper').attr("handle");
        if (iStockpHandle !== 'undefined') {
            istockgetProduct(iStockpHandle, istockFormWrap);
        }
    },
    300);
}
function istockInit() {
    var iCanUseOn = !!jQuery.fn.on;
    if (iCanUseOn) {
        jQuery("body").on('click', '.iStock-notify-btn',
        function(event) {
            istockNotifyClick(jQuery(this));
        });
        jQuery("body").on('change', iStockSelectClass,
        function() {
            jQuery(".iStock-wrapper").hide().find('.iStock-msg').hide();
            var istockFormWrap = jQuery(this).parents(iStockWraperClass);
            setTimeout(function() {
                istockNotifyShow(iStockProduct, istockFormWrap);
            },
            500)
        });
        if (typeof iStockQvButton !== 'undefined' && typeof iStockQvWrapper !== 'undefined') {
            jQuery("body").on('click', iStockQvButton,
            function() {
                istockInitQv(jQuery(this), jQuery(this).attr("handle"));
            });
            if (typeof iStockQvCloseButton !== 'undefined') {
                jQuery(document).on("click", 'body.iStock-qvopen',
                function(e) {
                    if (jQuery(e.target).is(iStockQvCloseButton) || jQuery(e.target).parents().not(iStockQvWrapper)) {
                        istockCloseQv();
                    }
                });
            }
        }

      jQuery("body").on('click','.email_me',function(){
        var iHandle = jQuery(this).attr('handle');
        var vid = jQuery(this).attr('vid');

        jQuery('#iStock-wrapper').attr('handle', iHandle);
        jQuery('#v_id').val(vid);
        jQuery("body").addClass('iStock-qvopen');
        jQuery(".iStock-wrapper").hide().find('.iStock-msg').hide();

        var istockFormWrap = jQuery(this).parents(iStockWraperClass);
        istockgetProduct(iHandle, istockFormWrap);
      });
    }

    if (typeof(Storage) !== "undefined") {
        if (sessionStorage.iStockShop && sessionStorage.iStockShop == iStockShop) {
            if (iStockIsProductpage) {
                var istockFormWrap = jQuery('.iStock-wrapper').parents(iStockWraperClass + ':visible');
                iStockpHandle = istockFormWrap.find('.iStock-wrapper').attr("handle");
                if (iStockpHandle !== 'undefined') {
                    istockgetProduct(iStockpHandle, istockFormWrap);
                }
            }
        } else {
            jQuery.ajax({
                url: iStockUrl + 'istock_init.php',
                data: {
                    shop: iStockShop
                },
                dataType: 'jsonp',
                jsonpCallback: 'iStockCallgetSessionback',
                success: function(json) {
                    if (json.length == 0) {
                        return ! 1;
                    }
                    iStockShop = sessionStorage.iStockShop = json.iStockShop;
                    iStockShopId = sessionStorage.iStockShopId = json.iStockShopId;
                    iStockavlDtFormat = sessionStorage.iStockavlDtFormat = json.iStockavlDtFormat;
                    istExcludeProd = sessionStorage.istExcludeProd = json.istExcludeProd;
                    istExcludeVar = sessionStorage.istExcludeVar = json.istExcludeVar;
                    if (iStockIsProductpage) {
                        var istockFormWrap = jQuery('.iStock-wrapper').parents(iStockWraperClass + ':visible');
                        iStockpHandle = istockFormWrap.find('.iStock-wrapper').attr("handle");
                        istockgetProduct(iStockpHandle, istockFormWrap);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {}
            });
        }
    }
    if (typeof istockInitFn !== "undefined" && typeof istockInitFn === 'function') {
        istockInitFn();
    }
}
if (window.addEventListener) {
    window.addEventListener("load", istockInit, !1);
} else if (window.attachEvent) {
    window.attachEvent("onload", istockInit);
} else {
    window.onload = istockInit;
}